import type { MantineSize } from '@mantine/core';
import { Group, rem, Title } from '@mantine/core';
import type { ToOptions } from '@tanstack/react-router';

import { AppleLogo as AppleLogoIcon } from '@apple/assets/icons';
import { Link } from '@apple/ui/link/Link';

type Props = {
	iconSize?: MantineSize | (string & {}) | number;
	labelSize?: MantineSize | (string & {}) | number;
	label?: string;
	to?: ToOptions['to'];
};

export function AppleLogo({ iconSize = 'md', labelSize = 'md', label, ...toProps }: Props) {
	if (toProps.to === undefined) {
		return <Logo iconSize={iconSize} labelSize={labelSize} label={label} />;
	}

	return (
		<Link {...toProps} aria-label={label} underline='never'>
			<Logo iconSize={iconSize} labelSize={labelSize} label={label} />
		</Link>
	);
}

type LogoProps = {
	iconSize: MantineSize | (string & {}) | number;
	labelSize: MantineSize | (string & {}) | number;
	label?: string;
};

function Logo({ label, labelSize, iconSize }: LogoProps) {
	const words = label?.split(' ');
	const firstWord = words?.shift();
	if (label) {
		return (
			<Group
				wrap='nowrap'
				align='center'
				justify='flex-start'
				gap={rem(4)}
				c='var(--mantine-color-bright)'
			>
				<AppleLogoIcon c='var(--mantine-color-bright)' size={iconSize} pb={3} />
				<Title order={1} size={labelSize} fw={600} textWrap='nowrap'>
					{firstWord}
				</Title>
				<Title
					order={1}
					size={labelSize}
					fw={600}
					textWrap='nowrap'
					c='var(--mantine-color-blue-text)'
				>
					{words?.join(' ')}
				</Title>
			</Group>
		);
	}

	return <AppleLogoIcon size={iconSize} />;
}
